import { mockConfig } from './common-config';

export const environment = {
  ...mockConfig,
  production: false,
  endpoint: 'http://localhost:5000/api/v1/',                                                                                                             
  notificationEndPoint: 'http://localhost:5000/bookings', 
  videoUrlLink: 'https://trucklotsqastorage.blob.core.windows.net/public-data/', 
};